// Add-to-cart without leaving the page: bump the cart count and flash the button.
document.addEventListener('submit', async (e) => {
  const f = e.target;
  if (!f.matches('.pdp__form')) return;
  e.preventDefault();
  const btn = f.querySelector('button[type=submit]');
  const label = btn.innerHTML;
  btn.disabled = true;
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('add failed');
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    btn.innerHTML = 'Added — <a href="/cart" style="text-decoration:underline;margin-left:6px">view cart</a>';
    setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 3500);
  } catch (err) {
    f.submit();
  }
});
